<div class="hinweis_verdienst position-relative">
  <div class="hinweis_text">
    Gehalt ist Lohn und Anerkennung zugleich. Wer eine Weiterbildung plant, sollte die
    Verdienstaussichten prüfen…
  </div>
  <img
    class="hinweis_img position-absolute"
    alt=""
    ngSrc="./assets/images/frau_rot.svg"
    width="110"
    height="100"
  />
</div>

<!-- Druck -->
<div class="d-none d-print-block">
  <i class="now-icon now-btn-icon-large now-icon-info" aria-hidden="true"></i>
  <ng-container *ngTemplateOutlet="hinweis"></ng-container>
</div>

@for (baustein of bausteine; track baustein) {
  <div class="baustein border_bottom" [innerHTML]="baustein"></div>
}

<ng-template #hinweis>
  <p>
    Dieses Element wird angezeigt, weil eine Berufszuordnung zu diesem Weiterbildungsangebot erfolgt
    ist. Diesen Service verantwortet die Bundesagentur für Arbeit.
  </p>
</ng-template>
